import { Dispatch, ReactElement, SetStateAction, useState } from 'react';
import { faUserAlt, faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled, useMediaQuery, Button } from '@mui/material';
import styles from '../common/styles/util.module.scss';
import {
  ExpandButton,
  fullName,
  IUser,
  variables,
  viewUserProfile,
} from '../common';

export function ViewUserProfile({
  user,
  edit,
  details,
  setEdit,
}: {
  user: IUser;
  edit: boolean;
  details: () => ReactElement;
  setEdit: Dispatch<SetStateAction<boolean>>;
}) {
  const [expand, setExpand] = useState(true);

  const matchesGridBreakpoint = useMediaQuery('(min-width:60em)', {
    noSsr: true,
  });

  const toggleExpand = () => setExpand(x => !x);
  return (
    <Wrapper>
      <Header>
        <h2>
          <FontAwesomeIcon icon={faUserAlt} size="1x" fixedWidth />
          <span>{fullName(user)}</span>
        </h2>

        {viewUserProfile(user)(edit) && (
          <Button
            className={styles['margin-right-auto']}
            onClick={() => setEdit(true)}>
            Edit
            <FontAwesomeIcon icon={faPencilAlt} size="1x" fixedWidth />
          </Button>
        )}

        <ExpandButton
          onClick={toggleExpand}
          value={expand}
          matchesGridBreakpoint={matchesGridBreakpoint}
        />
      </Header>
      {expand && (
        <>
          <Person>{details()}</Person>
        </>
      )}
    </Wrapper>
  );
}

const Wrapper = styled('article')(({ theme }) => ({
  display: 'grid',
  gridTemplateAreas: `
    "header"
    "person"
    `,
  gap: '2rem',

  '@media (min-width: 800px)': {
    gridTemplateColumns: '2fr 1fr',
    gridTemplateAreas: `
    "header header "
    "person person"
    `,
  },
}));

const Header = styled('header')(({ theme }) => ({
  gridArea: 'header',

  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',

  borderBottom: variables.basicBorder,
}));

const Person = styled('article')(({ theme }) => ({
  gridArea: 'person',

  '&>*+*': {
    marginTop: '0.5rem',
  },
}));
